{
  "fr": {
    "datatable": {
      "actions": {
        "bulk_action": "Action en masse",
        "bulk_edit": "Modification en masse",
        "clear_filters": "Effacer les filtres",
        "deselect_all": "Tout désélectionner",
        "select_all": "Tout sélectionner"
      },
      "labels": {
        "gridlines": "Quadrillage",
        "size": "Taille",
        "toggle_columns": "Basculer les colonnes"
      }
    }
  }
}